<script lang="ts">
    import { Observable } from "rxjs";
    import { spring } from "svelte/motion";

    import RewardsAmountFormatter from "../lib/RewardsAmountFormatter/RewardsAmountFormatter";

    //Props
    export let customerBalance: number | undefined;
    export let rewardsAmountFormatter: RewardsAmountFormatter;

    //Variables
    const springCount$ = spring<number>();
    let formattedCustomerBalance$: Observable<number>;

    //Reactive Statement
    $: {
        if (customerBalance || customerBalance === 0) {
            springCount$.set(customerBalance);
            formattedCustomerBalance$ =
                rewardsAmountFormatter.format($springCount$);
        }
    }
</script>

{#if $formattedCustomerBalance$ || $formattedCustomerBalance$ === 0}
    <span class="gw-rd-customer-balance">
        {$formattedCustomerBalance$}

        <slot name="points-name" />
    </span>
{/if}
